import { render, staticRenderFns } from "./registries-filter.vue?vue&type=template&id=e64f1470&"
import script from "./registries-filter.vue?vue&type=script&lang=js&"
export * from "./registries-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports